export const useBuildSortingParams = (
  sorting?: Array<Record<string, unknown>>,
): string | undefined => {
  const sort = sorting
    ?.map((sort) => `${sort.id}:${sort.desc ? 'desc' : 'asc'}`)
    .join(';')
  return sort
}
